/* ============================================================
   IGNITE — P8 POD NOTIFY ME (v3, fix definitiv duplicate)
   Detecteaza form-uri dupa variant_id (intr-un input hidden) si
   proceseaza doar PRIMUL form per produs, pe ambele tipuri de
   pagini (homepage cu featured products multiple + pagina produs).
   ============================================================ */

(function () {
  'use strict';

  var CONFIG = {
    productHandle: 'ignite-p8-p15-pod-2-pack',
    // Toate variantele POD-ului care declanseaza fix-ul.
    // Daca produsul are 4 variante, listele lor variant ID:
    podVariantIds: [
      '54612886192457'
      // Aroma "Cherry Ice + Lemon Lime" - prima varianta
      // (celelalte variante au alte ID-uri - se schimba prin variant picker)
    ],
    // Strategie: detectam si dupa "produs intreg" prin product handle
    // Vom recunoaste TOATE variantele oricarei pagini care e a POD-ului
    useHandleDetection: true,

    notifyButtonText: 'NOTIFY ME WHEN AVAILABLE',
    detailsButtonText: 'MAI MULTE DETALII',
    debug: true,
    newsletterSectionSelector: '.section-newsletter-feature',
    homepageUrl: '/'
  };

  function log() {
    if (!CONFIG.debug) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[POD-NOTIFY v3]');
    console.log.apply(console, args);
  }

  log('Script incarcat');

  /**
   * Verifica daca un form e pentru produsul POD.
   * Strategia: cauta in form un input hidden "product-id" sau in URL-ul de submit.
   */
  function isFormForPod(form) {
    // 1. Verifica daca pagina curenta e a produsului POD
    if (window.location.pathname.indexOf('/products/' + CONFIG.productHandle) !== -1) {
      // Suntem pe pagina produsului - TOATE form-urile sunt pentru POD
      return true;
    }

    // 2. Verifica input-ul de produs din form (Shopify pune product_id sau id)
    var productIdInput = form.querySelector('input[name="product-id"], input[name="product_id"]');
    if (productIdInput && productIdInput.value) {
      // E o referinta la produs - verificam in vecinatatea form-ului link-ul la produs
      var section = form.closest('[id^="shopify-section-"]');
      if (section && section.querySelector('a[href*="/' + CONFIG.productHandle + '"]')) {
        return true;
      }
    }

    // 3. Verifica daca form-ul are un link spre POD in vecinatate
    var section = form.closest('[id^="shopify-section-"]');
    if (section) {
      var linkToPod = section.querySelector('a[href*="/' + CONFIG.productHandle + '"]');
      if (linkToPod) return true;
    }

    return false;
  }

  /**
   * Returneaza un ID unic pentru "grup de form-uri" — adica toate form-urile
   * Focal duplicate care apartin aceluiasi container/sectiuni vizibile.
   *
   * Folosim section ID-ul + variantul ID ca cheie.
   */
  function getFormGroupKey(form) {
    var variantInput = form.querySelector('input[name="id"]');
    var variantId = variantInput ? variantInput.value : 'unknown';

    var section = form.closest('[id^="shopify-section-"]');
    var sectionId = section ? section.id : 'page-product';

    return sectionId + '::' + variantId;
  }

  function isFormProcessed(form) {
    return form.dataset.podNotifyProcessed === 'true';
  }

  function markFormProcessed(form) {
    form.dataset.podNotifyProcessed = 'true';
  }

  /**
   * Cauta toate form-urile POD si returneaza UN form per "grup unic".
   * Pe pagina produsului avem 1-2 forms care difera, si vrem doar primul.
   * Plus, in cazul Focal: e un form "principal" si unul "duplicate buy buttons" —
   * pe cel cu parent class "product-form__buy-buttons" il ignoram (pune
   * doar butoanele de payment, nu e formul principal).
   */
  function findPodForms() {
    var allForms = document.querySelectorAll('form[action*="/cart/add"]');
    var processedGroups = new Set();
    var podForms = [];

    allForms.forEach(function (form) {
      // Skip cele care nu sunt POD
      if (!isFormForPod(form)) return;

      // Skip "duplicate buy buttons" — cele care sunt doar pentru payment buttons,
      // nu pentru add-to-cart principal. Le identificam dupa parent class.
      var parentClass = (form.parentElement && form.parentElement.className) || '';
      if (parentClass.indexOf('product-form__buy-buttons') !== -1) {
        log('Sar peste form duplicat (buy-buttons):', getFormGroupKey(form));
        // Ascundem si butoanele din acest form, ca sa nu mai ramana butoane Focal vizibile
        var btns = form.querySelectorAll('button, .shopify-payment-button');
        btns.forEach(function (b) {
          b.style.display = 'none';
          b.setAttribute('data-pod-hidden', 'true');
        });
        return;
      }

      // Pentru fiecare grup unic, luam doar primul form
      var groupKey = getFormGroupKey(form);
      if (processedGroups.has(groupKey)) {
        log('Sar peste form duplicat (grup):', groupKey);
        return;
      }
      processedGroups.add(groupKey);

      podForms.push(form);
      log('Form POD principal:', groupKey);
    });

    return podForms;
  }

  function findInsertionPoint(form) {
    var candidates = [
      '.product-form__payment-container',
      '.product-form__buttons',
      '.product-form__cart'
    ];

    for (var i = 0; i < candidates.length; i++) {
      var el = form.querySelector(candidates[i]);
      if (el) return el;
    }

    return form;
  }

  function processForm(form) {
    if (isFormProcessed(form)) return;
    markFormProcessed(form);

    log('Procesez form principal');

    // Ascundem TOATE butoanele si quantity din form
    var hideSelectors = [
      'button[type="submit"]',
      '.product-form__add-button',
      '.shopify-payment-button',
      '[data-product-add-to-cart-button]',
      '.product-form__payment-container > button',
      '.product-form__quantity',
      'quantity-selector',
      '.quantity-selector',
      '.product-form__quantity-selector'
    ];

    hideSelectors.forEach(function (selector) {
      var elements = form.querySelectorAll(selector);
      elements.forEach(function (el) {
        el.style.display = 'none';
        el.setAttribute('data-pod-hidden', 'true');
      });
    });

    // Adaugam butoanele noastre
    var container = document.createElement('div');
    container.className = 'pod-notify-buttons';
    container.setAttribute('data-pod-buttons', 'true');
    container.innerHTML =
      '<button type="button" class="pod-notify-btn pod-notify-btn--primary" data-pod-notify>' +
      '<span class="pod-notify-icon" aria-hidden="true">&#9993;</span>' +
      '<span>' + CONFIG.notifyButtonText + '</span>' +
      '</button>' +
      '<button type="button" class="pod-notify-btn pod-notify-btn--secondary" data-pod-details>' +
      '<span>' + CONFIG.detailsButtonText + '</span>' +
      '<span class="pod-notify-arrow" aria-hidden="true">&rarr;</span>' +
      '</button>';

    var insertionPoint = findInsertionPoint(form);
    insertionPoint.appendChild(container);

    container.querySelector('[data-pod-notify]').addEventListener('click', handleNotifyClick);
    container.querySelector('[data-pod-details]').addEventListener('click', handleDetailsClick);
  }

  function handleNotifyClick(e) {
    e.preventDefault();
    e.stopPropagation();
    log('Click pe Notify me');

    var newsletterButton = document.querySelector('[data-nlf-open]');
    if (newsletterButton) {
      newsletterButton.click();
    } else {
      window.location.href = CONFIG.homepageUrl + '#open-newsletter';
    }
  }

  function handleDetailsClick(e) {
    e.preventDefault();
    e.stopPropagation();
    log('Click pe Mai multe detalii');

    var nlSection = document.querySelector(CONFIG.newsletterSectionSelector);
    if (nlSection) {
      nlSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.location.href = CONFIG.homepageUrl + '#newsletter-feature';
    }
  }

  function handleHashTriggers() {
    if (window.location.hash === '#open-newsletter') {
      setTimeout(function () {
        var btn = document.querySelector('[data-nlf-open]');
        if (btn) {
          btn.click();
          history.replaceState(null, '', window.location.pathname + window.location.search);
        }
      }, 500);
    }
    if (window.location.hash === '#newsletter-feature') {
      setTimeout(function () {
        var nl = document.querySelector(CONFIG.newsletterSectionSelector);
        if (nl) {
          nl.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', window.location.pathname + window.location.search);
        }
      }, 500);
    }
  }

  function process() {
    var forms = findPodForms();
    if (forms.length === 0) {
      log('Niciun form POD');
      return;
    }
    log('Procesez', forms.length, 'form-uri POD');
    forms.forEach(processForm);
  }

  function init() {
    log('Init');
    process();
    handleHashTriggers();

    var observer = new MutationObserver(function (mutations) {
      var shouldReprocess = false;
      mutations.forEach(function (m) {
        if (m.addedNodes && m.addedNodes.length > 0) {
          for (var i = 0; i < m.addedNodes.length; i++) {
            var node = m.addedNodes[i];
            if (node.nodeType === 1) {
              if ((node.id && node.id.indexOf('shopify-section-') === 0) ||
                  (node.querySelector && node.querySelector('form[action*="/cart/add"]'))) {
                shouldReprocess = true;
                break;
              }
            }
          }
        }
      });
      if (shouldReprocess) {
        setTimeout(process, 200);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(process, 100);
  });

})();